import React, { useContext } from 'react';
import { StaticContext } from '@sm/webassets';
import { sanitizeString } from '@sm/utils';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useTooltipStyles from './useStyles';
import { FeatureTooltipProps } from './types';

export default function FeatureTooltip({
  tooltipHeading,
  tooltip,
  isLastPackage,
}: Readonly<FeatureTooltipProps>): React.ReactElement {
  const {
    environment: { slLanguageLocale },
  } = useContext(StaticContext);

  const { TooltipLeft, TooltipRight, TooltipArrow } = useTooltipStyles({ locale: slLanguageLocale });

  return (
    <Box className={isLastPackage ? TooltipRight : TooltipLeft}>
      <Typography component="h5" variant="body" data-testid="Tooltip__Heading">
        {tooltipHeading}
      </Typography>
      <span
        data-testid="Tooltip"
        role="tooltip"
        aria-roledescription="A tooltip describing the functionality of the feature"
        dangerouslySetInnerHTML={{ __html: sanitizeString(tooltip, { ADD_ATTR: ['target'] }) }}
      />
      <span className={TooltipArrow} />
    </Box>
  );
}
